export const PLATFORM_ADMIN_ROOT = "/platform-admin";

export function isPlatformAdminPath(
  pathname = typeof window === "undefined" ? "" : window.location.pathname,
): boolean {
  return pathname === PLATFORM_ADMIN_ROOT || pathname.startsWith(`${PLATFORM_ADMIN_ROOT}/`);
}

// Convert a normal authenticated-app path into its dedicated platform-console
// equivalent. Keeping this in one place lets existing project screens be
// reused without ever sending an Access administrator through Better Auth.
export function adminHref(path: string): string {
  if (!isPlatformAdminPath()) return path;
  return `${PLATFORM_ADMIN_ROOT}${path === "/" ? "" : path}`;
}

export function resolveAdminApiUrl(input: string): string {
  if (!isPlatformAdminPath() || !input.startsWith("/api/admin")) return input;
  return `${PLATFORM_ADMIN_ROOT}/api${input.slice("/api/admin".length)}`;
}

export function redirectIfUnauthorized(): boolean {
  if (typeof window === "undefined") return false;
  const destination = isPlatformAdminPath() ? PLATFORM_ADMIN_ROOT : "/login";
  if (window.location.pathname === destination) return false;
  window.location.href = destination;
  return true;
}
